<div [ngClass]="[isActive ? 'active' : 'inactive', 'content-container']">
  <img [src]="imgUrl" [alt]="imgAlt">
  <h3>{{title}}</h3>
</div>

